import React, { useEffect } from "react";

import { Backtotop, Floatinmenu, Underline, Reunion_card } from "../../widgets";
import "../Library/Rules_and_regulations.css";
import { RadialMenu, Listformat } from "../../components";
import {
  librarymenu,
  libraryRules,
} from "../../constants/library";
import {FaBook} from "react-icons/fa";
import "./Library.css";
export default function Rules_and_regulations() {
  useEffect(() => {
    document.title = "ACCET-Library | Rules and Regulations";
  }, []);

  return (
    <>
      <div className="librarypage">
        <div className="librarybg">
          <div className="libraryheading">Library</div>
          <div className="library_sub_heading">Rules and Regulations</div>
        </div>
      </div>
      <section className="librarydark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaBook} head="Menu" links={librarymenu} />
        </div>
        <RadialMenu menu_links={librarymenu} />
      </section>
      <Backtotop />
      <div className="library-rules">
        <Underline heading="Library Rules and Regulations" />
        <Listformat points={libraryRules} />
      </div>
    </>
  );
}
